export function getErrorMessage(errors: any): string | null {
    if (!errors) return null;

    if (typeof errors.message === 'string') {
        return errors.message;
    }

    if (Array.isArray(errors)) {
        for (const error of errors) {
            const message = getErrorMessage(error);
            if (message) return message;
        }
    }

    if (typeof errors === 'object') {
        for (const key in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, key)) {
                const message = getErrorMessage(errors[key]);
                if (message) return message;
            }
        }
    }

    return null;
}

export function getErrorType(errors: any): string | null {
    if (!errors) return null;

    if (typeof errors.type === 'string') {
        return errors.type;
    }

    if (Array.isArray(errors)) {
        for (const error of errors) {
            const type = getErrorType(error);
            if (type) return type;
        }
    }

    if (typeof errors === 'object') {
        for (const key in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, key)) {
                const type = getErrorType(errors[key]);
                if (type) return type;
            }
        }
    }

    return null;
}
